import React from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";
import { AD_KIND_OPTIONS } from "../constants/adKindOptions";
import "./styles/AdKindPicker.css";

function AdKindPicker({ onSelect, className = "" }) {
  return (
    <div className={`ad-kind-picker ${className}`.trim()}>
      {AD_KIND_OPTIONS.map((item) => (
        <Link
          key={item.slug}
          to={`/goder/new/${item.slug}`}
          className="ad-kind-picker__card"
          onClick={onSelect}
        >
          <span className="ad-kind-picker__icon-wrap">
            <img src={item.image} className="ad-kind-picker__icon" alt="" />
          </span>
          <span className="ad-kind-picker__label">
            <Translate value={item.labelKey} />
          </span>
        </Link>
      ))}
    </div>
  );
}

export default AdKindPicker;
